export default "__VITE_PUBLIC_ASSET__a4ee2791__"